





























































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import moment from 'moment';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Image = {
  id: string,
  name: string,
  url: string,
};

type Spec = {
	id: string,
	concept_id: string,
	name: string,
	content: string,
	created_at: string,
	updated_at: string,
  name_placeholder: string,
  content_placeholder: string,
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string,

  cpcard_image: Image,
  specs: Spec[],
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,

  concepts: Concept[],
}

type Props = {
  pid: string;
};

export default defineComponent({
  name: "ConceptCompare",
  components: {
    NavHeader,
    Footer
  },
  props: {
    pid: {
      type: String,
      default: ''
    }
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/concept/compare01.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
    ]
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      selection: 'title',
      project: { name: '' } as Project,
      concepts: [] as Concept[],
    });
    const titleClass = computed(() => {
        return state.selection === 'title' ? 'active' : '';
    });
    const descClass = computed(() => {
        return state.selection === 'desc' ? 'active' : '';
    });
    const specClass = computed(() => {
        return state.selection === 'spec' ? 'active' : '';
    });

    async function loadImage(data: Blob): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(data);
      });
    }

    async function load() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      };

      const response = await API.get('dev', '/projects/' + props.pid, options);
      state.concepts = await Promise.all(response.data.concepts.map(async (cp: Concept) => {
        const response = await API.get('dev', '/concepts/' + cp.id, options);
        const detail: Concept = response.data.concept;
        detail.specs = response.data.specs;
        if (detail.cpcard_image_id) {
          options.queryStringParameters.pid = detail.project_id;
          options.queryStringParameters.cid = detail.id;

          const cpcard = await API.get('dev', '/images/cpcards/' + cp.cpcard_image_id, options);
          detail.cpcard_image = cpcard.data;

          const image = await axios.get(cpcard.data.url, { responseType: 'blob' });
          detail.cpcard_image.url = await loadImage(image.data);
        } else {
          detail.cpcard_image = { id: '', name: '', url: '/images/archive_img.png'};
        }
        return detail;
      }));
      state.project = response.data;

      console.log(state);
    }
    load();


    function moveToTitle() {
      state.selection = 'title';
      //document!.getElementById('app')!.scrollIntoView();
    };
    function moveToDesc() {
      state.selection = 'desc';
      //document!.getElementById('app')!.scrollIntoView();
    };
    function moveToSpec() {
      state.selection = 'spec';
      //document!.getElementById('app')!.scrollIntoView();
    };

    function specsToText (specs: Spec[]) {
      return specs.map((s) => {
        return s.name + '&ensp;' + s.content;
      }).join('<br>');
    };

    return {
      state,
      
      moveToTitle,
      moveToDesc,
      moveToSpec,

      titleClass,
      descClass,
      specClass,

      specsToText,
    };
  }

});
